import React from 'react';
import classes from './DatesFilter.module.css';
import DateTimePicker from 'containers/UI/DateSelection/DateTimePicker/DateTimePicker';
import { preparePostDateForSubmission } from 'shared/utility';

const datesFilter = (props) => {
  const containerClasses = [classes.Container];
  if (props.show) containerClasses.push(classes.Open);

  const handleDateSelect = (date, dateType) => {
    const formattedDate = date === 'Ongoing' ? 'ONGOING' : preparePostDateForSubmission(date, false);
    let updatedDate = props.dateStart !== null ? props.dateStart : '';

    if (dateType === 'dateStart' && date !== 'Ongoing') {
      // Start and end date are provided
      if (updatedDate.includes(' AND ')) {
        updatedDate = `${formattedDate} AND ${props.dateStart.split(' AND ')[1]}`;
      }
      // Start date only
      else {
        updatedDate = formattedDate;
      }
    } else if (date === 'Ongoing') {
      // If Ongoing is provided for end date, but no start date provided - If user chooses ongoing as their end date,
      // Riza adds today in Start date field
      updatedDate = props.dateStart
        ? `${props.dateStart.split(' AND ')[0]} AND ONGOING`
        : `${preparePostDateForSubmission(new Date(), false)} AND ONGOING`;
    } else if (dateType === 'dateEnd') {
      // End date provided, but no start date provided --> filter  automatically adds the same date
      if (!props.dateStart && dateType === 'dateEnd') {
        updatedDate = `${formattedDate} AND ${formattedDate}`;
      }
      // Start and end date are provided
      else if (props.dateStart) {
        updatedDate = `${props.dateStart.split(' AND ')[0]} AND ${formattedDate}`;
      }
    }

    props.handleDateStartChanged(updatedDate);
  };

  // const handleDateClear = (dateType) => {
  //   props.clear();
  // };
  const dateStart = props.dateStart ? props.dateStart.split(' AND ')[0] : null;
  const dateStartRangeEnd = props.dateStart && props.dateStart.split(' AND ').length > 1 ? props.dateStart.split(' AND ')[1] : '';
  const ongoing = props.dateStart && props.dateStart.includes('Ongoing');

  return (
    <div className={containerClasses.join(' ')}>
      <DateTimePicker
        type="LogFilters"
        visible={props.show}
        openedDrawer={null}
        dateStart={dateStart}
        dateEnd={dateStartRangeEnd}
        handleDateSelect={handleDateSelect}
        requireStartDateBeforeEndDate
        ongoing={ongoing}
        handleOngoingSelection={() => handleDateSelect('Ongoing', 'dateEnd')}
      />
      <div className={classes.Controls}>
        <div className={classes.SelectOptions}>
          <p onClick={props.clear}>Clear</p>
        </div>
        <p onClick={props.submit}>SAVE</p>
      </div>
    </div>
  );
};

export default datesFilter;
